/**
 * ES3-1661 Firefox-Bugfix for loading the CKEditor in a Bootstrap dialog.
 * Otherwise some form fields are not selectable in popups (e.g. the popup for adding a link).
 *
 * http://stackoverflow.com/questions/14420300/bootstrap-with-ckeditor-equals-problems
 */
$.fn.modal.Constructor.prototype.enforceFocus = function() {
    modal_this = this;
    $(document).on('shown.bs.modal', function (e) {
        if (modal_this.$element[0] !== e.target && !modal_this.$element.has(e.target).length
            && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_select')
            && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_text')) {
            modal_this.$element.focus();
        }
    })
};